app.controller('CheckoutDeliveryController', [
  '$scope',
  'Config',
  'CacheFactory',
  'delivery',
  '$window',
  'helper',
  'cart',
  'quote',
  '$interval',
  function ($scope, Config, CacheFactory, delivery, $window, helper, cart, quote, $interval) {

    $scope.base_url = Config.base_url;
    $scope.insideWorkingHours = Config.insideWorkingHours;
    $scope.outsideWorkingHours = Config.outsideWorkingHours;
    $scope.cart = cart.getCart();
    $scope.showPoReference = false;
    $scope.sameTransportDates = false;
    
    $scope.CountDown = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      getTimeRemaining: function (endtime) {
        var t = Date.parse(endtime) - Date.parse(new Date());
        var seconds = Math.floor((t / 1000) % 60);
        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
          'total': t,
          'days': days,
          'hours': hours,
          'minutes': minutes,
          'seconds': seconds
        };
      },
      //starts the countdown by setting tlif.enabled flag set to true/false depending on the time difference between quote creation datetime and tlif duration
      initializeClock: function (endtime) {
        function updateClock() {
          var t = $scope.CountDown.getTimeRemaining(endtime);
  
          var dateDifference = moment($scope.quote.created_on).add($scope.quote.tlif.tlif_min_count, 'm').add($scope.quote.server_date_offset, 'milliseconds').diff(new Date);
  
          // if(dateDifference>0){
          // 	if ($scope.quote.tlif.enabled!=true){
          // 		$scope.quote.tlif.enabled = true;
          // 	}
          // } else {
          // 		$scope.quote.tlif.enabled = false;
          // }
          $scope.$applyAsync();
          $scope.CountDown.days = t.days < 10 ? '0' + t.days : t.days;
          $scope.CountDown.hours = ('0' + t.hours).slice(-2);
          $scope.CountDown.minutes = ('0' + t.minutes).slice(-2);
          $scope.CountDown.seconds = ('0' + t.seconds).slice(-2);

          
				  if(t.total == 1000){
					  $scope.updateTlifStatus();
				  }
  
          if ((t.total <= 0) || ($scope.quote.discountCode)) {
            $interval.cancel(timeinterval);
            $scope.quote.tlif.enabled = false;
          } else {
            if ($scope.quote.tlif.enabled != true) {
              $scope.quote.tlif.enabled = true;
            }
  
          }
        }
  
      
        updateClock();
        var timeinterval = $interval(updateClock, 1000);
        
      }
    }

    $scope.init = function () {
      helper.showTransLoader();
      setTimeout(function() {
        helper.hideTransLoader();
      }, 1000);
      //check if the quote cache exist otherwise redirect to details page

      if(angular.isDefined($scope.cart) && $scope.cart.cartChanged == true) {
        $window.location.href = $scope.base_url + 'checkout/details';
      }
      else if(
        (!angular.isDefined(CacheFactory.get('appCache').get('quote')) || !angular.isDefined(CacheFactory.get('appCache').get('quote').quote_limitations)
          && CacheFactory.get('appCache').get('quote').quote_limitations 
          && CacheFactory.get('appCache').get('quote').quote_limitations.limitations == true)
      || (!CacheFactory.get('appCache').get('quote').passedQuoteStage)){
        $window.location.href = $scope.base_url+'checkout/quote';
      }
      else if (!angular.isDefined(CacheFactory.get('appCache').get('quote')) || !angular.isDefined(CacheFactory.get('appCache').get('cart'))) {
        if (helper.getParameterByName('quote-id')) {
          $scope.retrieveQuote(helper.getParameterByName('quote-id'));
          

        } else {
          $window.location.href = $scope.base_url + 'checkout/details';
        }
      } else {
        $scope.quote = CacheFactory.get('appCache').get('quote');
        if ((typeof $scope.quote.tlif !== 'undefined')&&($scope.quote.tlif)) {
          var deadline = moment($scope.quote.created_on).add($scope.quote.tlif.tlif_min_count, 'm').add($scope.quote.server_date_offset,'milliseconds').toDate();
          $scope.CountDown.initializeClock(deadline);
        }

        $scope.deliveryDate = moment.unix($scope.quote.deliveryDateTimestamp + ($scope.quote.deliveryDateOffset * 86400)).format("DD/MM/YYYY");
        $scope.collectionDate = moment.unix($scope.quote.collectionDateTimestamp + ($scope.quote.collectionDateOffset * 86400)).format("DD/MM/YYYY");

        if($scope.deliveryDate == $scope.collectionDate){
          $scope.sameTransportDates = true;
        }

        $scope.getInstallDerig();
        $scope.getSurcharges();
        $scope.showBacs();
        //check if there is info stored in the cache then use that
        if (angular.isDefined(CacheFactory.get('appCache').get('delivery'))) {
          $scope.transport = CacheFactory.get('appCache').get('delivery');
        } else {
          $scope.transport = {
            'delivery': {
              'install': 'no',
              'installCost': 0,
              'option': null,
              'timeSlots': $scope.insideWorkingHours,
              'timeStart': '08:00',
              'timeEnd': '18:00',
              'startReadOnly': true
            },
            'collection': {
              'derig': 'no',
              'derigCost': 0,
              'option': null,
              'timeSlots': $scope.insideWorkingHours,
              'timeStart': '08:00',
              'timeEnd': '18:00',
              'startReadOnly': true
            }
          }
        }

        $scope.checkMandatoryService();

      }
    }

    $scope.handleSameDayDelivery = function(surcharges, type) {
      if(angular.isDefined(CacheFactory.get('appCache').get('details_transport'))){
        var temp_transport = CacheFactory.get('appCache').get('details_transport');
        var code = type == 'delivery' ? 'DEL' : 'COL';
        var key = type == 'delivery' ? 'Delivery' : 'Collection';
        $scope.transport[type].timeStart = temp_transport[type].timeStart;
        $scope.transport[type].timeEnd = temp_transport[type].timeEnd;
        $scope.transport[type].timeSlots = temp_transport[type]?.actual_timeslots;
        $scope.transport[type].timeSlots = temp_transport[type].actual_timeslots;
        $scope.transport[type].startReadOnly = false;

        if(code == 'DEL'){
          $scope.transport[type].install = temp_transport?.[type]?.install || $scope.transport[type].install;
          $scope.transport[type].installCost = temp_transport?.[type]?.installCost || $scope.transport[type].installCost;
        }
        else {
          $scope.transport[type].derig = temp_transport?.[type]?.derig || $scope.transport[type].derig;
          $scope.transport[type].derigCost = temp_transport?.[type]?.derigCost || $scope.transport[type].derigCost;
        }
  
        var inside = 'no';
        Config.insideWorkingHours.forEach((function(value, idx) {
          if(value == moment($scope.transport[type].timeStart,'HH:mm').format('HH')){
            inside = 'yes'
          }
        }))
  
        if(inside == 'no') $scope.transport[type].timeSlots = $scope.outsideWorkingHours;
        else $scope.transport[type].timeSlots = $scope.insideWorkingHours;
  
        
        var surcharge = surcharges[`${type}_surcharges`].find(surcharge => surcharge.carriage_surcharge_code == `${code}TIMED` && surcharge.inside_working_hours == inside);
        $scope.transport[type].option = surcharge;
        $scope[`checked${key}Radio`] = surcharge.carriage_surcharge_id;
      } 
    }

    $scope.getInstallDerig = function () {
      data = {
        brand: Config.brand_key,
        deliveryPostcode: $scope.quote.deliveryPostcode,
        collectionPostcode: $scope.quote.deliveryPostcode,
        cartTotalWeight: cart.totalWeight()
      }
      delivery.getInstallDerig(data).then(function (response) {
        $scope.transport.delivery.installCost = response.data.install;
        $scope.transport.collection.derigCost = response.data.derig;
      }, function (response) {
        // console.log(response);
      });
    }

    $scope.getSurcharges = function () {
      data = {
        brand: Config.brand_key,
        deliveryPostcode: $scope.quote.deliveryPostcode,
        collectionPostcode: $scope.quote.deliveryPostcode
      }
      delivery.getSurcharges(data).then(function (response) {
        $scope.surcharges = response.data;
        $scope.handleSameDayDelivery(response.data, 'delivery');
        $scope.handleSameDayDelivery(response.data, 'collection');
      }, function (response) {
        // console.log(response);
      });
    }

    $scope.label = function (name, price) {
      return name + " (" + price + ")";
    }

    $scope.setTimeSlot = function (type) {
      if (!$scope.transport[type].option) {
        $scope.transport[type].timeStart = '08:00';
        $scope.transport[type].timeEnd = '18:00';
        $scope.transport[type].startReadOnly = true;
      } else {
        $scope.transport[type].timeStart = moment($scope.transport[type].option.start_time, 'HH:mm').format('HH:mm');
        if ($scope.transport[type].option.end_time) {
          //set start to read only
          $scope.transport[type].startReadOnly = true;
          $scope.transport[type].timeSlots = $scope.insideWorkingHours;
          $scope.transport[type].timeEnd = moment($scope.transport[type].option.end_time, 'HH:mm').format('HH:mm');
        } else {
          $scope.transport[type].startReadOnly = false;
          //set timeslots array by subtracting duration of current option
          if($scope.transport[type].option.inside_working_hours=='yes'){
            $scope.transport[type].timeSlots = $scope.insideWorkingHours;
            $scope.transport[type].timeStart = '08:00';
          }else{
            $scope.transport[type].timeSlots = $scope.outsideWorkingHours;
            $scope.transport[type].timeStart = '07:00';
          }
          $scope.getEndSlot(type);
        }
      }
    }
    

    $scope.getEndSlot = function (type) {
      end = parseInt(moment($scope.transport[type].timeStart, 'HH:mm').format('HH')) + parseInt($scope.transport[type].option.duration);
      if (end > 24) {
        //check if end time will be more than 24
        $scope.transport[type].timeEnd = moment(end - 24, 'HH:mm').format('HH:mm');
      } else {
        $scope.transport[type].timeEnd = moment((parseInt(moment($scope.transport[type].timeStart, 'HH:mm').format('HH')) + parseInt($scope.transport[type].option.duration)), 'HH:mm').format('HH:mm');
      }
    }

    $scope.filterTimeSlots = function (slots, duration) {
      var filteredSlots = [];
      //get highest number in array
      var newEnd = slots.slice(-1).pop() - duration;
      //loop through slots and only get numbers lower or equal to new end
      slots.forEach(function (slot) {
        if (slot <= newEnd) {
          filteredSlots.push(slot);
        }
      });
      return filteredSlots;
    }

    $scope.checkOption = function(surcharge) {
      if($scope.sameTransportDates){
        switch (surcharge) {
          case 'DELST':
            return true;
          case 'DELAMPM':
            return true;
          case 'COLST':
            return true;
          case 'COLAMPM':
            return true;
          default:
            return false
        }
      }
      return false;
    }

    $scope.saveDelivery = function (form) {
      if (form.$valid) {
        helper.showTransLoader();
        //HACK
        $scope.transport = helper.timedHackCalc($scope.transport, $scope.surcharges);
        //call API to save delivery checklist in the webquotes table
        delivery.saveDeliveryChecklist($scope.transport, $scope.quote.webQuoteID).then(function (response) {
          //cache delivery and collection options
          CacheFactory.get('appCache').put('delivery', $scope.transport);
          CacheFactory.get('appCache').remove('details_transport');
          //then redirect to payment step
          if ($scope.quote.buy_option == 'yes') {
            $window.location.href = $scope.base_url + 'buy';
          } else {
            $window.location.href = $scope.base_url + 'checkout/payment';
          }
        }, function (response) {
          // console.log(response);
        });
      }
    }

    $scope.checkMandatoryService = function (quoteID) {
      var quoteID = $scope.quote.webQuoteID;

      delivery.isServiceMandatory($scope.cart.content).then(function (response) {
        if (response.data.mandatoryService) {
          $scope.serviceLock = true;
          $scope.transport.delivery.install = 'yes';
          $scope.transport.collection.derig = 'yes';
        } else {
          $scope.serviceLock = false;
        }

      });
    }

    

    $scope.retrieveQuote = function (quoteID) {
      //check if the quote is valid and not expired
      helper.showTransLoader();
      quote.retrieveQuote(quoteID, helper.getParameterByName('token')).then(function (response) {

        //if valid then retrive it
        if (helper.getParameterByName('token') != $('#user_token').val()) {
          location.reload();
        } else {
          //clear JS session & add quote to the session
          cart.content = [];
          CacheFactory.get('appCache').removeAll();
          var quoteRes = response.data;

          //set quote data
          $scope.quote = quoteRes;
          $scope.checkLimitations();

          if (typeof $scope.quote['buy_option'] == 'undefined') {
            $scope.quote.buy_option = 'no';
          }
          if ($scope.quote.buy_option == 'yes') {
            $scope.getCartQuantityDifference($scope.cart, $scope.buyingCart);
          }
          $scope.hireWeeks = ($scope.quote.hireDays != 1) ? Math.round(($scope.quote.hireDays / 7) + 0.35) : $scope.quote.hireDays;
          $scope.deliveryDate = moment.unix($scope.quote.deliveryDateTimestamp + ($scope.quote.deliveryDateOffset * 86400)).format("DD/MM/YYYY");
          $scope.collectionDate = moment.unix($scope.quote.collectionDateTimestamp + ($scope.quote.collectionDateOffset * 86400)).format("DD/MM/YYYY");
          //update cache variables
          CacheFactory.get('appCache').put('quote', quoteRes);
          CacheFactory.get('appCache').put('hireDays', $scope.quote.hireDays);
          CacheFactory.get('appCache').put('hireWeeks', $scope.hireWeeks);
          CacheFactory.get('appCache').put('deliveryDate', moment.unix($scope.quote.deliveryDateTimestamp + ($scope.quote.deliveryDateOffset * 86400)).format("YYYY-MM-DD"));
          CacheFactory.get('appCache').put('collectionDate', moment.unix($scope.quote.collectionDateTimestamp + ($scope.quote.collectionDateOffset * 86400)).format("YYYY-MM-DD"));
          cart.setCart(quoteRes.cart);
          CacheFactory.get('appCache').put('retrievedQuote', true);
          //if retrival coming from a remarketing campain then store that a click happened
          if (helper.getParameterByName('utm_term')) {
            quote.updateUtmTerm(helper.getParameterByName('utm_term'), $scope.quote.webQuoteID);
          }
          helper.hideTransLoader();
          location.reload();

        }



      }, function (response) {
        if (response.status == 406) {
          //if not then show an error
          $scope.retrievedQuote = response.data;
          alert('Your quote expired. Please add new products to get a quote.');
          $window.location.href = $scope.base_url + 'checkout/details';

          helper.hideTransLoader();
        }
      });
    }
    
    $scope.showBacs = function(){
        var endDate = moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400)).toDate();
        var startDate = moment().toDate();
        var result = -1;
        var currentDate = startDate;
      
        //At least 3 working days away for bacs
        while (currentDate <= endDate)  {  
          var weekDay = currentDate.getDay();
          if(weekDay != 0 && weekDay != 6) 
            result++;
          currentDate.setDate(currentDate.getDate()+1); 
        }
      
        if(result >= 3 && $scope.quote.company != ''){
          $scope.showPoReference = true;
        }
        else {
          $scope.showPoReference = false;
        }
    }
    
    $scope.checkLimitations = function (){
      $http({
        method: 'POST',
        url: Config.api_url+'quote/check-limitations',
        data: {data: $scope.quote},
        headers:{
          'authorization':Config.api_key
        }
        }).then(function(response) {
          $scope.quote.quote_limitations = response.data
          if(response.data.limitations == true){
            $window.location.href = $scope.base_url+'checkout/quote';
          }
        })
    }

    
    $scope.updateTlifStatus = function() {
      data = {
        token: $scope.quote.token,
        webquote_id: $scope.quote.webQuoteID
      }
      quote.updateTlifStatus(data)
    }

  }
  
]);

app.filter('formatSlot', function () {
  return function (slots) {
    var filteredSlots = [];
    //loop through and return addresses with matching postcodes
    angular.forEach(slots, function (slot, key) {
      slot = moment(slot, "HH:mm").format("HH:mm");
      filteredSlots.push(slot);
    });
    return filteredSlots;
  };
});
